import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  MenuItem,
  Snackbar,
  Alert
} from "@mui/material";

const roles = [
  { label: "Administrador", value: "ADMIN" },
  { label: "Vendedor", value: "VENDOR" },
  { label: "Superusuario", value: "SUPER" }
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "#fff",
  borderRadius: "10px",
  p: 3,
  boxShadow: 24
};

const NewUser = ({ open, onClose, onCreated }) => {
  const [form, setForm] = useState({
    nombre: "",
    correo: "",
    telefono: "",
    rol: "VENDOR"
  });

  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    type: "success"
  });

  const getCSRF = async () => {
    const r = await fetch("/sistema/get-csrf-token/");
    const d = await r.json();
    return d.csrfToken;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const crearUsuario = async () => {
    if (!form.nombre || !form.correo) {
      setSnack({
        open: true,
        msg: "Nombre y correo son obligatorios",
        type: "error"
      });
      return;
    }

    const csrf = await getCSRF();

    const res = await fetch("/sistema/crear-usuario/", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrf
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (data.ok) {
      setSnack({
        open: true,
        msg: "Usuario creado correctamente",
        type: "success"
      });
      setForm({
        nombre: "",
        correo: "",
        telefono: "",
        rol: "VENDOR"
      });
      onCreated();
      onClose();
    } else {
      setSnack({
        open: true,
        msg: "Error al crear usuario",
        type: "error"
      });
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <Typography
            variant="h6"
            sx={{ mb: 2, fontWeight: "bold", color: "#1565C0" }}
          >
            Crear nuevo usuario
          </Typography>

          <TextField
            label="Nombre completo"
            name="nombre"
            fullWidth
            value={form.nombre}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Correo electrónico"
            name="correo"
            fullWidth
            value={form.correo}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Teléfono"
            name="telefono"
            fullWidth
            value={form.telefono}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Rol"
            name="rol"
            select
            fullWidth
            value={form.rol}
            onChange={handleChange}
            sx={{ mb: 3 }}
          >
            {roles.map((r) => (
              <MenuItem key={r.value} value={r.value}>
                {r.label}
              </MenuItem>
            ))}
          </TextField>

          <Button
            variant="contained"
            fullWidth
            onClick={crearUsuario}
            sx={{
              backgroundColor: "#1565C0",
              "&:hover": { backgroundColor: "#0D47A1" },
              textTransform: "none"
            }}
          >
            Guardar usuario
          </Button>
        </Box>
      </Modal>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snack.type} sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default NewUser;
